import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { HotelResponseTime } from '../../../../components/commonClass/CommonValidation';
import { loaderActions } from '../../../../_actions/loader.actions';
import { getData, postUsersData } from '../../../../services/ApiCallingUserServices';
import { getSortedData } from '../../../../components/commonClass/DataSorting';
import { CommonFileURLWithFolder } from '../../../../ImageUpload/ImageCommon';
import HotelFilter from './Partial/HotelFilter';
import HotelSearchList from './Partial/HotelSearchList';
import FilterFormHotels from '../../partial/FilterFormHotels';


const HotelList = () => {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const [hotelList, setHotelList] = useState<any>(null);
    const [hotelCopyList, setHotelCopyList] = useState<any>(null);
    const [filterList, setFilterList] = useState<any>({});
    const [hotelFilter, setHotelFilter] = useState<any>({
        CheckIn: "",
        CheckOut: "",
        HotelCodes: "",
        GuestNationality: "IN",
        PaxRooms: [{
            Adults: 1,
            Children: 0,
            ChildrenAges: null
        }],
        ResponseTime: HotelResponseTime,
        IsDetailedResponse: true,
        Filters: {
            Refundable: false,
            NoOfRooms: 0,
            MealType: 0,
            OrderBy: 0,
            StarRating: 0,
            HotelName: null
        },
        CityCode: 0, ///  If City Is selected then City Code need to pass here,
        UserRating: [],
        Amenities: [],
        Price: 0,
    });
    // Fetch hotel list data
    const getHotelList = async (data: any) => {
        dispatch(loaderActions.start());
        await postUsersData('/customerui/v1/gethotellistfilters', data)?.then((rep: any) => {
            if (rep?.status) {
                const copy = rep?.data?.hotelResult ? rep?.data?.hotelResult : [];
                const column = 'hotelDetails?.[0]?.hotelRating'
                const sortedList = getSortedData(copy, false, column, 'number'); // by default sort by high -> low rating hotels

                setHotelList(rep?.data?.hotelResult ? sortedList : null);
                setHotelCopyList(rep?.data?.hotelResult ? sortedList : []);

                setFilterList((previous: any) => ({
                    ...previous,
                    hotelFacilities: rep?.data?.hotelFacilities?.sort((a: any, b: any) => {
                        if (a.toLowerCase() < b.toLowerCase()) return -1;
                        if (a.toLowerCase() > b.toLowerCase()) return 1;
                        return 0;
                    }),
                    userRatings: rep?.data?.userRatings,
                }));
                dispatch(loaderActions.end());
            }
            else {
                setHotelList([]);
                setHotelCopyList([])
                dispatch(loaderActions.end());
            }
        });
    };

    // Fetch filter data
    const getFilterData = async () => {
        const rep = await getData('/customerui/v1/gethoteluiconfigurations');
        if (rep?.status) {
            setFilterList((previous: any) => ({
                ...previous,
                userRatingTitle: rep?.data?.userRating,
                bannerdetails: rep?.data?.bannerdetails,
                bannerImageURL: `${CommonFileURLWithFolder}${rep?.data?.bannerdetails?.[0]?.ImagePath}`
            }));
        }
    };

    useEffect(() => {
        getFilterData();
    }, [])


    const fetchData = async (hotelFilter: any) => {
        getHotelList(hotelFilter);
    };

    useEffect(() => {
        const obj = Object.fromEntries(searchParams.entries());
        if (obj?.isExplore === "true" || isInitialLoad) {

            const transformObject = (obj: any) => {
                const paxRooms = [];

                let roomId = 1;
                while (obj[`roomReq${roomId}noOfAdult`] !== undefined) {
                    const adultsKey = `roomReq${roomId}noOfAdult`;
                    const childrenKey = `roomReq${roomId}noOfChildren`;
                    const childrenAgesKey = `roomReq${roomId}childrenAge`;

                    let adults = obj[adultsKey] ? Number(obj[adultsKey]) : 0;
                    let children = obj[childrenKey] ? Number(obj[childrenKey]) : 0;
                    let childrenAges = [];

                    if (children > 0) {
                        for (let j = 1; j <= children; j++) {
                            const childAge = obj[`${childrenAgesKey}${j}`];
                            if (childAge) {
                                childrenAges.push(Number(childAge));
                            }
                        }
                    }

                    paxRooms.push({
                        "Adults": adults,
                        "Children": children,
                        "ChildrenAges": childrenAges.length > 0 ? childrenAges : null
                    });

                    roomId++;
                }

                const filterObj = {
                    "CheckIn": obj.CheckIn,
                    "CheckOut": obj.CheckOut,
                    "HotelCodes": obj.HotelCodes,
                    "GuestNationality": obj.GuestNationality,
                    "PaxRooms": paxRooms,
                    "ResponseTime": HotelResponseTime,
                    "IsDetailedResponse": true,
                    "Filters": {
                        "Refundable": false,
                        "NoOfRooms": 0,
                        "MealType": 0,
                        "OrderBy": 0,
                        "StarRating": 0,
                        "HotelName": obj.HotelName,
                    },
                    "CityCode": obj.CityCode ? Number(obj.CityCode) : 0,
                    // "UserRating": obj?.UserRating ? decryptUrlDatapattern(obj?.UserRating) : [],
                    // "Amenities": obj?.Amenities ? obj?.Amenities?.split(',') : [],
                    // "Price": Number(obj?.Price) > 0 ? Number(obj?.Price) : 0
                };
                setHotelFilter(filterObj);
                return filterObj
            };
            if (transformObject(obj)?.HotelCodes?.trim()?.length > 0 || transformObject(obj)?.CityCode > 0) {
                fetchData(transformObject(obj));
            }

            setIsInitialLoad(false);
            const urlParams: any = new URLSearchParams(searchParams);
            urlParams.set('isExplore', false)
            setSearchParams(urlParams)
        }


    }, [searchParams]);

    const backgroundImage = useMemo(() => {
        return filterList?.bannerdetails?.[0]?.ImagePath
            ? `${CommonFileURLWithFolder}${filterList?.bannerdetails?.[0]?.ImagePath}`
            : `${require("../../../../assets/img/no-image.png")}`;
    }, [filterList]);

    return (
        <>
            <section className="filterSec detailsBanner">
                <img
                    loading='lazy'
                    className='holidayBannerSec hotel-list-filter'
                    src={backgroundImage}
                    alt="holiday banner images"
                    onError={(e: any) => e.target.src = require("../../../../assets/img/banner-slider3.jpg")}
                />

                <div className="FilterDiv">
                    <div className="container">
                        <FilterFormHotels isdisabled={false} />
                    </div>
                </div>
            </section>

            {hotelCopyList !== null && <section className="midSection">
                <div className="container">
                    <div className="row">
                        <HotelFilter
                            filterList={filterList}
                            setHotelList={setHotelList}
                            hotelCopyList={hotelCopyList}
                        />
                        <HotelSearchList hotelList={hotelList} setHotelList={setHotelList} />
                    </div>
                </div>
            </section>}
        </>
    )
}

export default HotelList;